import { useCallback, useState } from 'react';
import { getFavoritesCount } from './favorites';
import { useStorageSync } from './useStorageSync';

/**
 * Live count of all favorited items (claims + tow-requests). Re-evaluates on
 * the in-page `itow-favorites-changed` event (dispatched by `toggleFavorite`)
 * and the cross-tab `storage` event so badges stay in sync everywhere.
 */
export function useFavoritesCount(): number {
  const [count, setCount] = useState(() => getFavoritesCount());
  const update = useCallback(() => setCount(getFavoritesCount()), []);
  useStorageSync('itow-favorites-changed', update);
  return count;
}
